import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-caidan",
  "use": "icon-caidan-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-caidan\"><path fill=\"#333333\" d=\"M204.805 112.645h819.189v102.399H204.805zM204.805 460.801h716.79v102.398h-716.79zM204.805 808.956h511.993v102.399H204.805zM0.006 112.645h102.399v102.399H0.006zM0.006 460.801h102.399v102.398H0.006zM0.006 808.956h102.399v102.399H0.006z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol